import { IShimmerStyles, IStyle, mergeStyleSets } from "@fluentui/react";
import { Theme } from "@mui/material";
import { SxProps } from "@mui/system/styleFunctionSx/styleFunctionSx";
import { CSSProperties } from "react";

export const CONSUMPTION_REVENUE_TAB_STYLES = {
  CLASS_NAMES: mergeStyleSets({
    customCardContainer: {
      columnGap: 10,
      display: "flex",
      margin: 8
    } as CSSProperties
  }),
  CSS_STYLES: {
    shimmerWrapper: {
      shimmerWrapper: {
        "& .ms-ShimmerElementsGroup-root > .ms-ShimmerGap-root": {
          background: "white"
        },
        width: "580px !important"
      } as IStyle
    } as IShimmerStyles,
    filterStack: {
      paddingTop: "20px",
      paddingBottom: "20px",
      paddingLeft: "14px"
    } as CSSProperties,
    shimmerBox: {
      flexGrow: 1,
      pl: 0.5,
      pr: 0.5
    } as SxProps<Theme>,
    chartBox: {
      flexGrow: 1,
      pl: 0.5,
      pr: 0.5
    } as SxProps<Theme>,
    tableBox: {
      flexGrow: 1,
      pl: 1.5,
      pr: 1.5,
      pb: 1
    } as SxProps<Theme>,
    warningBannerContainer: {
      ml: 1.5, mr: 1.5
    } as SxProps<Theme>
  }
};

export const STYLES = CONSUMPTION_REVENUE_TAB_STYLES;
export const CLASS_NAMES = CONSUMPTION_REVENUE_TAB_STYLES.CLASS_NAMES;
export const CSS_STYLES = CONSUMPTION_REVENUE_TAB_STYLES.CSS_STYLES;
